"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgramSourceTypes = {
    default: 0,
    fordIncentives: 1
};
